import { Col, Collapse, Form, Row, Space, Switch, Tooltip } from 'antd';
import MultiSelect from '../common/FormControls/MultiSelect';
import { useItemCategories } from "./apiQueries"
import { ItemClass, ItemClasses } from '../../common/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilterList } from '@fortawesome/pro-solid-svg-icons';

type Props = {
  selectedClassIds: number[]
  onSelectedClassIdsChange: (data: number[]) => void
  selectedCategories: string[]
  onSelectedCategoriesChange: (data: string[]) => void
  expanded: boolean
  onExpandedChange: (expanded: boolean) => void
}

type ItemClassSwitchProps = {
  itemClass: ItemClass
  name: string
  selectedClassIds: number[]
  onChange: (checked: boolean, itemClass: ItemClass) => void
}
const ItemClassSwitch = ({ itemClass, name, selectedClassIds, onChange }: ItemClassSwitchProps) => {
  return <Space>
    <Switch checked={selectedClassIds.includes(itemClass)} onChange={checked => onChange(checked, itemClass)} />
    {name}
  </Space>
}

const ItemFilters = ({ selectedClassIds, onSelectedClassIdsChange, selectedCategories, onSelectedCategoriesChange, expanded, onExpandedChange }: Props) => {
  const itemCategories = useItemCategories(expanded)

  const hasFilters = selectedClassIds.length > 0 || selectedCategories.length > 0

  const onClassChange = (checked: boolean, itemClass: ItemClass,) => {
    if (checked) {
      onSelectedClassIdsChange([...selectedClassIds, itemClass])
    } else {
      onSelectedClassIdsChange(selectedClassIds.filter(x => x !== itemClass))
    }
  }

  return <Form layout="vertical" style={{ width: '100%' }}>
    <Collapse
      activeKey={expanded ? 'filters' : undefined}
      onChange={() => onExpandedChange(!expanded)}
      style={{ backgroundColor: 'white' }}
      items={[
        {
          key: 'filters',
          label:
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              Filters
              {hasFilters && <Tooltip title="Filters applied" mouseEnterDelay={1}><FontAwesomeIcon icon={faFilterList} /></Tooltip>}
            </div>,
          children: [
            <Form.Item label="Item Classes" key="filter-item-classes">
              <Row>
                <Col span={13}>
                  <ItemClassSwitch itemClass={ItemClasses.Labor} onChange={onClassChange} selectedClassIds={selectedClassIds} name="Labor" />
                </Col>
                <Col>
                  <ItemClassSwitch itemClass={ItemClasses.Equipment} onChange={onClassChange} selectedClassIds={selectedClassIds} name="Equipment" />
                </Col>
              </Row>
              <Row>
                <Col span={13}>
                  <ItemClassSwitch itemClass={ItemClasses.Materials} onChange={onClassChange} selectedClassIds={selectedClassIds} name="Materials" />
                </Col>
                <Col>
                  <ItemClassSwitch itemClass={ItemClasses.Subcontracting} onChange={onClassChange} selectedClassIds={selectedClassIds} name="Subcontracting" />
                </Col>
              </Row>
            </Form.Item>,
            <Form.Item label="Categories" key="filter-item-categories">
              <MultiSelect
                style={{ minWidth: 200, maxWidth: 500 }}
                placeholder="Filter categories"
                selectedValues={selectedCategories}
                onChange={onSelectedCategoriesChange}
                maxTagCount={2}
                labelFieldName="name"
                valueFieldName="name"
                options={itemCategories.data || []}
              />
            </Form.Item>
          ]
        }
      ]}
    />
  </Form>
}


export default ItemFilters
